import { useMutation, useQuery } from "@tanstack/react-query";
import IntercomClient from "../clients/IntercomClient";
import { useApi } from "@equidefi/portals/hooks/useApi";

export const useIntercomCreateTicket = (options) => {
  const intercomApi = useApi(IntercomClient);
  return useMutation((data) => intercomApi.createTicket(data, options));
};

export const useIntercomGetTicketTypes = (options) => {
  const intercomApi = useApi(IntercomClient);

  return useQuery(["ticket-types"], () => intercomApi.getTicketTypes(), options);
};
